module.exports = __webpack_public_path__ + "img/background-todos.313abe50.png";